import React, { Component } from "react";
import "./App.css";

import { BrowserRouter, Switch, Route } from "react-router-dom";

import Navbar from "./components/layout/Navbar";
import Dashboard from "./components/dashboard/Dashboard";
import AddDoctor from "./components/doctor/AddDoctor";
import Doctor from "./components/doctor/Doctor";
import IndividualDoctor from "./components/doctor/IndividualDoctor";
import SignIn from "./components/auth/SignIn";
import Admin from "./components/admin/Admin";
import Directorio from "./components/paciente/Directorio";

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <Route path="/" component={Navbar} />
          <Switch>
            <Route exact path="/signin" component={SignIn} />
            <Route exact path="/" component={Dashboard} />
            <Route exact path="/dashboard" component={Dashboard} />
            <Route exact path="/doctors" component={Dashboard} />
            <Route exact path="/patients" component={Directorio} />
            <Route exact path="/addDoctor" component={AddDoctor} />
            <Route exact path="/editDoctor" component={AddDoctor} />
            <Route exact path="/admin" component={Admin} />
            <Route path="/doctors/:id" component={Doctor} />
            <Route exact path="/doctor/:id" component={IndividualDoctor} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
